import React from "react";
import defaultBarOutdoor from "../../../../assets/images/default-bar-outdoor.png";

const BarCard = ({ bar, onClick }) => {
  if (!bar) return null;

  const getBarPhoto = () => {
    if (bar.outdoor_photos?.photos?.length > 0)
      return bar.outdoor_photos.photos[0];
    return defaultBarOutdoor;
  };

  const handleBarPhotoError = (e) => {
    e.currentTarget.src = defaultBarOutdoor;
  };

  return (
    <div className="bar-card" onClick={onClick}>
      <div className="bar-photo">
        <img
          src={getBarPhoto()}
          alt={bar.name || "Bar"}
          onError={handleBarPhotoError}
        />
      </div>
      <div className="bar-info">
        <h3 className="bar-name">{bar.name || "Unknown Bar"}</h3>
        {bar.address && (
          <p className="bar-address">📍 {bar.address}</p>
        )}
      </div>
    </div>
  );
};

export default BarCard;
